<div class="confirm-modal">
  <img src="../../../../assets/img/devis_refused.svg" alt="sent demand" />
  <p class="confirm-modal__message">
    {{
      "MODALS.DEVIS_PRIX.MESSAGE"
        | translate
          : {
            prix: minPrix,
            }
    }}
  </p>
  <div class="confirm-modal__buttons">
    <app-button
      [innerText]="'MODALS.DEVIS_PRIX.BUTTON' | translate"
      (onClick)="handleCancle()"
    ></app-button>
  </div>
</div>
